import React from 'react';
import {useTranslation} from 'react-i18next';
import Close from '../../../../../../component/close/Close';
import * as css from './HeaderComponent.css';
import {Button} from '@tickchak/react-share/app';
import Add from '../../../../../../assets/icons/add';

interface HeaderComponentProps {
    planEventsCount: number;
    mandatoryCount: number;
    optionalCount: number;
    onCreateEvent: () => void;
    onClose: () => void;
    subscriptionTitle: string;
    subscriptionSubtitle: string;
    showEventKind: boolean;
}

function HeaderComponent({planEventsCount, mandatoryCount, optionalCount, onCreateEvent, onClose, subscriptionTitle, subscriptionSubtitle, showEventKind}: HeaderComponentProps) {
    const {t} = useTranslation('subscriptions');

    return (
        <css.header>
            <Close className="" onClick={onClose} />
            <css.headerTop>
                <css.subscriptionTitle>{subscriptionTitle}</css.subscriptionTitle>
                <css.subscriptionSubtitle>{subscriptionSubtitle}</css.subscriptionSubtitle>
            </css.headerTop>
        
            <css.headerBottom>
                <css.createEventButton>
                    <Button 
                        variant="primary"
                        size='category'
                        onClick={onCreateEvent}
                        iconStart={<Add width={12} height={12} />}
                    >
                        {t('createNewEvent')}
                    </Button>
                </css.createEventButton>
                <css.summaryLabels>
                    <css.summaryLabel className="all">
                        {planEventsCount}
                        <css.summaryText className="all">{t('allEvents')}</css.summaryText>
                    </css.summaryLabel>
                    {showEventKind && <>
                        <css.summaryLabel className="mandatory">
                            {mandatoryCount}
                            <css.summaryText className="mandatory">{t('mandatoryEvents')}</css.summaryText>
                        </css.summaryLabel>
                        <css.summaryLabel className="optional">
                            {optionalCount}
                            <css.summaryText className="optional">{t('optionalEvents')}</css.summaryText>
                        </css.summaryLabel>
                    </>}
                </css.summaryLabels>
            </css.headerBottom>
        </css.header>
    );
}

export default HeaderComponent;
